<template>
  <transition name="slide" mode="out-in">
    <ModalWindow
      :extraClasses="'add-option-modal acl-login-modal'"
      v-if="showModal"
      @close="cancelModal"
      :closeBtnText="'Cancel'"
      :showCloseIcon="true"
      :showCloseBtn="false"
    >
      <template slot="body">
        <validation-observer v-slot="{ handleSubmit }" ref="form">
          <div class="login-window">
            <div class="login-block text-center">
              <a href="/" class="d-block logo-container">
                  <img  src="/images/logo.svg" alt="NCC LOGO" width="180" height="54">
              </a>
              <div class="login-header login">
                <h1>Login to Job Portal</h1>
              </div>
              <form class="login-form" @submit.prevent="handleSubmit(onSubmit)">
                <validation-provider
                  name="email"
                  rules="required|email"
                  v-slot="{ errors }"
                  tag="div"
                  class="form-group"
                >
                  <div class="form-group text-left">
                    <label for="email">
                      Email Address:
                      <span class="required">*</span>
                    </label>
                    <div class="input-wrapper has-icon">
                      <input
                        type="text"
                        name="email"
                        v-model="email"
                        :class="{'input-error':errors.length}"
                        placeholder="Your Email"
                        autocomplete="off"
                        id="email"
                      />
                      <i class="far fa-envelope"></i>
                      <div class="invalid-feedback">{{ errors[0] }}</div>
                    </div>
                  </div>
                </validation-provider>

                <validation-provider
                  name="password"
                  rules="required"
                  v-slot="{ errors }"
                  tag="div"
                  class="form-group"
                >
                  <div class="form-group text-left">
                    <label for="password">
                      Password:
                      <span class="required">*</span>
                    </label>
                    <div class="input-wrapper has-icon">
                      <input
                        :type="password_field_type"
                        name="password"
                        v-model="password"
                        :class="{'input-error':errors.length}"
                        placeholder="Your Password"
                        autocomplete="off"
                        id="password"
                      />
                      <i
                        class="far cooo"
                        :class="{'fa-eye-slash':password_field_type=='password', 'fa-eye':password_field_type=='text'}"
                        @click="togglePasswordEye"
                      ></i>
                      <div class="invalid-feedback">{{ errors[0] }}</div>
                    </div>
                  </div>
                </validation-provider>

                <validation-provider
                  name="remember"
                  rules="required"
                  tag="div"
                  class="remember-login d-flex flex-wrap align-items-center justify-content-between m-b-20"
                >
                  <input type="checkbox" v-model="remember" id="remember" />
                  <label for="remember">Remember me</label>
                  <a
                    href="/password/reset"
                    target="_blank"
                    class="link-to-route"
                  >Forgot your password?</a>
                </validation-provider>

                <button
                  type="submit"
                  class="primary-btn w-100 btn-mid text-capitalize"
                  :class="{'spinner-loading':is_submitted}"
                >
                  Log In To Your
                  Account
                </button>
                <p class="global-failure-feedback" v-if="error_message">{{ error_message }}</p>
                <p class="global-success-feedback" v-if="success_message">{{ success_message }}</p>
              </form>
            </div>
          </div>
        </validation-observer>
      </template>
    </ModalWindow>
  </transition>
</template>

<style lang="scss">
.login-window {
  .login-block {
    padding: 6rem 6.6rem;
    @media (max-width: 767px) {
      padding: 0;
    }
  }
  .logo-container {
    margin-bottom: 3rem;
    transition: none;
  }
  h1 {
    font-size: 2.4rem;
    line-height: 3.2rem;
    font-weight: 500;
    margin-bottom: 3rem;
    color: var(--primary-color);
  }
  input {
    &:not([type="checkbox"]) {
      padding: 0.9rem 2rem;
    }
  }
  input[type="checkbox"] {
    width: auto;
  }
  .cooo {
    line-height: 4.5rem;
    pointer-events: auto;
    cursor: pointer;
  }
}
.acl-login-modal {
  .v-modal-title {
    margin: 0;
    line-height: 0;
    font-size: 0;
  }
  .close-btn-with-icon {
    right: -15px;
    top: -30px;
    &:hover {
      color: var(--action-color);
    }
  }
}
</style>

<script>
const Swal = require("sweetalert2");

export default {
  props: ["EventshowModal", "email_address"],
  data() {
    return {
      showModal: false,
      is_submitted: false,
      email: "",
      password: "",
      password_field_type: "password",
      remember: true,
      error_message: "",
      success_message: "",
    };
  },
  components: {
    ModalWindow: require("@/components/global/Modal").default,
  },
  watch: {
    EventshowModal: {
      handler: function (val) {
        this.showModal = val;
      },
      immediate: true,
    },
    email_address: {
      handler: function (val) {
        this.email = val;
      },
      immediate: true,
    },
  },
  methods: {
    cancelModal: function () {
      this.$nextTick(() => this.$refs.form.reset());
      this.$parent.showLoginModal = false;
      this.email = "";
      this.password = "";
    },
    togglePasswordEye: function (e) {
      if (this.password_field_type == "password") {
        this.password_field_type = "text";
      } else {
        this.password_field_type = "password";
      }
    },
    onSubmit: function (e) {
      this.error_message = "";
      this.success_message = "";
      this.is_submitted = true;
      axios
        .post("/login", {
          email: this.email,
          password: this.password,
          remember: this.remember,
        })
        .then((response) => {
          this.success_message = "Login success! Redirecting to dashboard.";
          window.location.href = window.location.href;
          this.is_submitted = false;
        })
        .catch((error) => {
          this.is_submitted = false;
          if (error.response.status == 422) {
            this.error_message = error.response.data.message;
            this.$refs.form.setErrors(error.response.data.errors);
          } else {
            this.error_message = "Something wrong at form!";
          }
        });
    },
  },
};
</script>
